import { post } from '@/utils/request'

//订单出餐列表
export function PostOrderList(data) {
    return post('admin/order/orderDeliveryList', data)
}
//订单出餐操作
export function PostSetDiningOut(data) {
    return post('admin/order/setDiningOut', data)
}